var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "import-image-modal",
            title: _vm.modalTitle,
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
          },
          on: { show: _vm.onModalOpen, hide: _vm.onModalHide },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentStep === 1,
                  expression: "currentStep === 1",
                },
              ],
              staticClass: "upload-image-container mt-3",
            },
            [
              _c("Vue2Dropzone", {
                ref: "fileInput",
                attrs: {
                  id: "ImportImageDropzone",
                  options: _vm.dropzoneOptions,
                },
                on: {
                  "vdropzone-file-added": _vm.setFile,
                  "vdropzone-removed-file": _vm.setFile,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.templateSelectAvailable
            ? _c(
                "div",
                { staticClass: "mb-3" },
                [
                  _c("Multiselect", {
                    staticClass: "mb-3",
                    attrs: {
                      options: _vm.layouts,
                      loading: _vm.isLoading,
                      searchable: "",
                      multiple: "",
                      "custom-label": _vm.customLabel,
                      "track-by": "id",
                      placeholder: "Select layout",
                    },
                    on: {
                      "search-change": _vm.searchCustomerLayouts,
                      select: (option) => (_vm.selectedLayout = [option]),
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.layouts.length < _vm.layoutsTotalCount
                          ? {
                              key: "afterList",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "load-more-btn" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            disabled: _vm.isLoading,
                                            variant: "outline-primary",
                                          },
                                          on: { click: _vm.getLayouts },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Load More\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.selectedLayout,
                      callback: function ($$v) {
                        _vm.selectedLayout = $$v
                      },
                      expression: "selectedLayout",
                    },
                  }),
                  _vm._v(" "),
                  !_vm.createLayers
                    ? _c("b-form-radio-group", {
                        attrs: {
                          name: "select-strategy",
                          options: _vm.options,
                        },
                        model: {
                          value: _vm.selectedStrategy,
                          callback: function ($$v) {
                            _vm.selectedStrategy = $$v
                          },
                          expression: "selectedStrategy",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.createLayers &&
                  _vm.selectedStrategy ===
                    _vm.IMPORT_INTO_EXISTS_TEMPLATE_STRATEGY
                    ? _c("SelectTemplateBanner", {
                        staticClass: "mt-3",
                        attrs: { customers: _vm.customers },
                        model: {
                          value: _vm.selectedTemplates,
                          callback: function ($$v) {
                            _vm.selectedTemplates = $$v
                          },
                          expression: "selectedTemplates",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "mt-3",
              attrs: { switch: "" },
              model: {
                value: _vm.createLayers,
                callback: function ($$v) {
                  _vm.createLayers = $$v
                },
                expression: "createLayers",
              },
            },
            [_vm._v("\n      Create Layers\n    ")]
          ),
          _vm._v(" "),
          _vm.createLayers
            ? _c("small", { staticClass: "text-muted d-block" }, [
                _vm._v("\n      Select one image to create layers.\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex",
              class:
                _vm.currentStep > 1
                  ? "justify-content-between"
                  : "justify-content-end",
            },
            [
              _vm.currentStep > 1
                ? _c(
                    "b-button",
                    {
                      staticClass: "mt-3",
                      attrs: { variant: "outline-primary" },
                      on: { click: _vm.handlePrevStep },
                    },
                    [_vm._v("\n        ← Previous Step\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mt-3",
                  attrs: {
                    disabled: !_vm.nextStepAvailable,
                    variant: "outline-primary",
                  },
                  on: { click: _vm.handleNextStep },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.currentStep < 2 ? "Next Step " : "Import ") +
                      "→\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-overlay", {
            attrs: { show: _vm.isImporting, "no-wrap": "" },
            scopedSlots: _vm._u([
              {
                key: "overlay",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-center d-flex flex-column align-items-center justify-content-center",
                      },
                      [
                        _c("b-spinner", {
                          staticClass: "mb-2",
                          attrs: { variant: "primary" },
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.loadingText) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isSelectImageModalMounted
        ? _c("SelectFolderModal", {
            attrs: {
              "modal-id": _vm.SELECT_IMAGE_MODAL_ID,
              "modal-title": "Select Image",
              "view-tabs": "",
              "show-layouts": false,
              "show-create-layers": "",
            },
            on: { onSelectedItems: _vm.onSelectImageConfirmed },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }